export const assetSelector = (state) => state?.asset;
